import PropTypes from 'prop-types';
import React from 'react';

import ViewportPage from './ViewportPage';
import ElementContainer from './ViewportPage/ElementContainer';
import TextOverflowButton from './ViewportPage/TextOverflowButton';

function VirtualPage ({ page, elements }) {
  return (
    <ViewportPage {...page}>
      {elements.map((element) => (
        <div key={`${element.pageId}-${element.id}`} className="element-container" data-id={element.id} data-page-id={element.pageId}>
          <ElementContainer
            width={element.width}
            height={element.height}
            x={element.x}
            y={element.y}
            rotation={element.rotation}
          >
            {element.type === 'text' && (
              <>
                {element.prev && (
                  <TextOverflowButton position='left' isLinked />
                )}
                <TextOverflowButton position='right' isLinked={!!element.next} />
              </>
            )}
          </ElementContainer>
        </div>
      ))}
    </ViewportPage>
  );
}

VirtualPage.displayName = 'VirtualPage';
VirtualPage.propTypes = {
  page: PropTypes.object,
  index: PropTypes.number,
  elements: PropTypes.array,
  relativePages: PropTypes.array
};

export default VirtualPage;
